module.exports = __webpack_public_path__ + "media/greek_7_echo_hall.3219971e.wav";